// extracted by mini-css-extract-plugin
export var avatarContainer = "_4b-1";
export var largeAvatarContainer = "_4b-2";
export var smallAvatarContainer = "_4b-0";